import { isEmpty } from 'lodash-es';
import { ICandidate } from 'wisestep-api';
import { formatDateInDayMonthYearTime } from 'wisestep-base';

import { booleanList } from '../helper/menuList';

const setSkills = (skills) => {
  if (!isEmpty(skills)) {
    return skills.map((skill) => {
      return { skill: skill, score: 0, yearsUsed: 0 };
    });
  }
  return [];
};

const setEducation = (edu) => {
  if (!isEmpty(edu)) {
    return edu.map((candidateEducation) => {
      return {
        org: candidateEducation.org,
        degree: candidateEducation.degree,
        major: candidateEducation.major,
        periodStart: !isEmpty(candidateEducation.periodStart)
          ? candidateEducation.periodStart
          : {
              year: 0,
              month: 0,
              day: 0,
            },
        periodEnd: !isEmpty(candidateEducation.periodEnd)
          ? candidateEducation.periodEnd
          : {
              year: 0,
              month: 0,
              day: 0,
            },
      };
    });
  }
  return [];
};

const setExperience = (exp) => {
  const allExp: {
    title: '';
    org: '';
    periodStart: {
      year: null;
      month: null;
      day: null;
    };
    periodEnd: {
      year: null;
      month: null;
      day: null;
    };
  }[] = [];
  if (!isEmpty(exp.current)) {
    allExp.push({
      title: exp.current.title,
      org: exp.current.org,
      periodStart: !isEmpty(exp.current.periodStart)
        ? exp.current.periodStart
        : {
            year: 0,
            month: 0,
            day: 0,
          },
      periodEnd: !isEmpty(exp.current.periodEnd)
        ? exp.current.periodEnd
        : {
            year: 0,
            month: 0,
            day: 0,
          },
    });
  }
  if (!isEmpty(exp.history)) {
    exp.history.map((candidateExp) => {
      allExp.push({
        title: candidateExp.title,
        org: candidateExp.org,
        periodStart: !isEmpty(candidateExp.periodStart)
          ? candidateExp.periodStart
          : {
              year: 0,
              month: 0,
              day: 0,
            },
        periodEnd: !isEmpty(candidateExp.periodEnd)
          ? candidateExp.periodEnd
          : {
              year: 0,
              month: 0,
              day: 0,
            },
      });
    });
  }
};

export const prowAndProFormDefaultValues = (candidate: ICandidate | null) => {
  if (candidate) {
    return {
      name: candidate.name ?? '',
      email: candidate.email ?? '',
      phone: candidate.phoneNumber ?? '',
      socialLinks: candidate.profileURLs ?? [],
      dob: candidate.dob ? formatDateInDayMonthYearTime(candidate.dob) : null,
      portfolio: candidate.portfolio ?? '',
      currentLocation: candidate.currentLocation,
      candidateSkills: !isEmpty(candidate.candidateSkills)
        ? candidate.candidateSkills
        : setSkills(candidate.skills),
      experience: !isEmpty(candidate.experience) ? setExperience(candidate.candidateSkills) : null,
      education: !isEmpty(candidate.education) ? setEducation(candidate.education) : null,
      militaryService: !isEmpty(candidate.militaryService)
        ? setExperience(candidate.militaryService)
        : null,
      language: 'English',
      ssnNumber: candidate.ssnNumber,
      payRate: candidate.payRate,
      availableFrom: candidate.availableFrom,
      isPreviousEmployee:
        candidate.isPreviousEmployee != null
          ? candidate.isPreviousEmployee
            ? booleanList['Yes']
            : booleanList['No']
          : null,
      providedServiceThroughThirdParty:
        candidate.providedServiceThroughThirdParty != null
          ? candidate.providedServiceThroughThirdParty
            ? booleanList['Yes']
            : booleanList['No']
          : null,
      subContractedWorker:
        candidate.subContractedWorker != null
          ? candidate.subContractedWorker
            ? booleanList['Yes']
            : booleanList['No']
          : null,
      isH1B:
        candidate.isH1B != null ? (candidate.isH1B ? booleanList['Yes'] : booleanList['No']) : null,
      flsaClassification: candidate.flsaClassification,
      supplierNotes: candidate.supplierNotes,
      summary: candidate.summary,
    };
  } else {
    return {};
  }
};
